module.exports = __webpack_public_path__ + "static/media/logout.154acad0.svg";